import React from "react";
import { useMount } from "react-use";

import { EnableCameraAccess } from "@src/views/EnableCameraAccess";
import { useWindowReload } from "@src/hooks/useWindowReload";

import { useIncode } from "./IncodeContext";

export const CameraAccess = () => {
  const { track } = useIncode();
  const onComplete = useWindowReload();

  useMount(() => track("enable_camera_access_viewed"));

  return <EnableCameraAccess onComplete={onComplete} />;
};
